export default "<p>dashboard-line-graph works!</p>\r\n";